import HttpService from "@/utils/httpData"
import { APP_CONFIG } from '@/utils/constants'

const getAllClasses = params => {
    //let apiEndpoint = `class/get-all`;
    let apiEndpoint = `class/ListBookGroupClass`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).
    catch(e => { return false });
}
const getEBooks = params => {
    //let apiEndpoint = `book/ListBookGroupType`;
    let apiEndpoint = `book/book-list`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getEBooksDetail = id => {
    let apiEndpoint = `book/${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getTraningId = id => {
    let apiEndpoint = `Book/GetTrainingIdByBook?bookId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getEBooksType = params => {
    //let apiEndpoint = `book/list-book-by-type-group-classes`;
    //let apiEndpoint = `book/book-list-by-type`;    
    let apiEndpoint = `book/list-book-by-type-and-classes`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


const getEBooksClass = params => {
    let apiEndpoint = `book/list-book-by-type-and-classes`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getExerciseDetail = id => {
    let apiEndpoint = `subjects/${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


const getQuestionByLesson = id => {
    let apiEndpoint = `lessons/${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getBookRelation = id => {
    let apiEndpoint = `book/list-book-relates/${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getPageSearch = keyword => {
    let apiEndpoint = `book/book-search?keyword=${keyword}`;
    return HttpService.get2(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getMediaListInLibsNoPagination = params => {
    let apiEndpoint = `library/ListBookLinknNoPagination`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getFilters = params => {
    let apiEndpoint = `book/BookFillter`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getBookRelate = params => {
    let apiEndpoint = `library/GetListReferentBookPageLink`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getMediaDetailInLibs = id => {
    let apiEndpoint = `library/GetBookPageLink?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getBookFAQ = id => {
    let apiEndpoint = `book/get-book-faq?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const getQuestionBookPage = params => {
    let apiEndpoint = `Book/get-list-question?bookId=${params.bookId}&bookIndexId=${params.bookIndexId}&pageIndex=${params.pageIndex}&numberOfPage=${params.numberOfPage}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getMediaInBookPage = params => {
    let apiEndpoint = `Book/get-list-page-link?bookId=${params.bookId}&bookPageId=0&pageNo=${params.pageNo}&keyword=${params.keyword}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const createPracticeCorrect = payload => {
    let apiEndpoint = `practice/Create-user-practice`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const updatePracticeCorrect = payload => {
    let apiEndpoint = `practice/Update-user-practice`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const removePracticeCorrect = id => {
    let apiEndpoint = `practice/DeleteUserPractice`;
    return HttpService.post(apiEndpoint, { id }).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getMediaRelateInBookPage = (params = {}) => {
    // let apiEndpoint = `Book/GetListPageLink`;
    let apiEndpoint = `Book/get-list-page-other_link`;
    // Book/get-list-page-other_link?bookId=475&BookPageId=626&pageIndex=1&pageSize=6
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(() => { return false });
}

export const setTimeReadBook = payload => {
    let apiEndpoint = `Home/BookDoneReading`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(() => { return false });
}

export const getAreaQuestionOnPage = id => {
    let apiEndpoint = `Question/GetQuestionLocationDetailByQuestionId?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(() => { return false });
}
export const getLessonOnPage = (bookId, pageStart, pageStop) => {
    let apiEndpoint = `lesson/get-list-by-book-pageno?bookid=${bookId}&pageStart=${pageStart}&pageStop=${pageStop}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(() => { return false });
}
export const getLessonInfo = id => {
    let apiEndpoint = `lesson/detailinfo?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(() => { return false });
}

export const GetCountQuestionIndex = (id,pageStart,pageStop) => {
    let apiEndpoint = `practice/GetCountQuestionIndex?bookId=${id}&pageStart=${pageStart}&pageStop=${pageStop}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
    }).catch(() => { return false });
}

export const getQuestionAreas = (bookId, pageNo) => {
    let apiEndpoint = `Question/list-question-location-by-bookid-and-pageno`
    return HttpService.post(apiEndpoint, {bookId, pageNo}).then(res => {
        return res && res.data && !res.data.errors && res.data.data && res.data.data.list ? res.data.data.list : null;
    }).catch(() => { return false })
}

export const getLessonAreas = (bookId, pageNo) => {
    let apiEndpoint = `lesson/list-lessonplan-location-by-bookid-and-pageno`
    return HttpService.post(apiEndpoint, {bookId, pageNo}).then(res => {
        return res && res.data && !res.data.errors && res.data.data && res.data.data.list ? res.data.data.list : null;
    }).catch(() => { return false })
}

// const getEBooksGroup = params => {
//     //let apiEndpoint = `book/list-book-by-type-group-classes`;
//     let apiEndpoint = `book/get-book-group-by-type`;    
//     return HttpService.post(apiEndpoint,params).then(res => {
//             return res.data ? res.data : null;
//     }).catch(e => {return false});
// }
export default {
    getEBooks,
    getEBooksDetail,
    getEBooksType,
    getEBooksClass,
    getAllClasses,
    getExerciseDetail,
    getQuestionByLesson,
    getBookRelation,
    getPageSearch,
    getFilters,
    getBookFAQ,
    getTraningId
    //getEBooksGroup,
};